<template>

    <div class="container-new order-right-summary" style="text-align: left;">
        <div class="ors-time-and-date" v-if="orderData.warehouse">
            <div class="col-auto col-divided"><strong>Punkt podjęcia:</strong>
                <em>Agata Meble - {{orderData.warehouse.City}}
                <br/>{{orderData.warehouse.Street}} {{orderData.warehouse.StreetNo}}<br/>
                    {{orderData.warehouse.PostalCode}} {{orderData.warehouse.City}}
                </em>
            </div>

            <div v-if="step > 2" class="col-auto col-divided"><strong>Adres realizacji:</strong>
                <em>{{orderData.address.Street}} {{orderData.address.StreetNo}}<br/>{{orderData.address.PostalCode}} {{orderData.address.City}}</em>
            </div>
            <div v-if="step > 2 && orderData.delivery.zoneName" class="col-auto col-divided">
                <strong>Strefa transportowa:</strong><em>{{orderData.delivery.zoneName}}</em>

            </div>
            <div class="col-auto" v-show="orderData.delivery.distance"><strong>Dystans:</strong><em>{{orderData.delivery.distance}} km</em></div>
            <div class="clear"></div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'deliveryPointSection',
        props: ['step', 'orderData'],
        data () {
            return {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// DeliveryPointSection.vue?1f5ed509